import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Stethoscope } from "lucide-react";

export default function ProfessionalLogin() {
  const navigate = useNavigate();
  const { loginWith } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.user.role !== "professional") {
        toast.error("This portal is for care providers only. Patients log in at /login.");
        return;
      }
      loginWith(data.user);
      toast.success(`Welcome back, ${data.user.name.split(" ")[0]}!`);
      navigate("/professional/dashboard", { replace: true });
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16 md:py-24" data-testid="pro-login-page">
      <div className="bg-white rounded-3xl border border-[#EDF1EF] shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-8">
        <span className="w-12 h-12 rounded-2xl bg-[#D9E4E1] flex items-center justify-center mb-5">
          <Stethoscope className="w-6 h-6 text-[#4A7065]" />
        </span>
        <h1 className="font-heading text-3xl text-slate-900">Professional Login</h1>
        <p className="text-sm text-slate-500 mt-1">Care providers' portal — for dietitians, fellow doctors and allied professionals.</p>

        <form onSubmit={submit} className="mt-7 space-y-4">
          <div>
            <Label htmlFor="pro-login-email">Registered email</Label>
            <Input id="pro-login-email" data-testid="pro-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 rounded-xl" />
          </div>
          <div>
            <Label htmlFor="pro-login-pass">Password</Label>
            <Input id="pro-login-pass" data-testid="pro-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 rounded-xl" />
          </div>
          <Button data-testid="pro-login-submit" type="submit" disabled={loading} className="w-full rounded-full bg-[#5E8B7E] hover:bg-[#4A7065] py-6">
            {loading ? "Logging in…" : "Login"}
          </Button>
        </form>

        <p className="text-sm text-slate-500 text-center mt-6">
          New here?{" "}
          <Link to="/professional/register" data-testid="pro-login-register-link" className="text-[#2C557E] font-medium hover:underline">
            Register as a care provider
          </Link>
        </p>
      </div>
    </div>
  );
}
